import React from 'react';
import ReactDOM from 'react-dom/client';
// Maven Pro served with the app instead of from Google Fonts: no third-party request, and it works
// offline in the installed app (IMP-090)
import '@fontsource-variable/maven-pro/wght.css';
import './styles/tokens.css';
import './index.css';
// Shared UI styles load before page stylesheets so page layout classes can override them
import './components/ui/Button.css';
import './components/ui/TextField.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './installPrompt.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Installable, app-like experience on phones (IMP-096)
registerServiceWorker();
